/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/17
 * Time: 09:38
 * Desc: 云店设置-基础配置
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';

@Component
export default class AppBasicConfig extends Vue {
  /* 数据 */

  /**
   * 小程序配置
   * @type {string}
   */
  public appConfig: ItemObject = {};

  /**
   * 选择的模块
   * @type {Array<ItemObject>}
   */
  public selectedDeploy: Array<ItemObject> = [];

  /**
   * 选中的模块索引
   * @type {number}
   */
  public selectModularIndex = -1;

  /**
   * 是否显示编辑弹窗
   * @type {boolean}
   */
  public isShowEdit = false;

  /**
   * 选中的模块
   * @type {deploy}
   */
  public selectModular: deploy = {};

  /**
   * 选中的图标
   * @type {ItemObject}
   */
  public chooseIcon: ItemObject = {};

  /**
   * 图标列表
   * @type {ItemObject}
   */
  public iconList: Array<ItemObject> = [];

  /**
   * 配置模块默认为主页索引
   * @type {number}
   */
  public isDefaultIndex = 4;

  /**
   * 主题类型
   * @type {string}
   */
  public themeType = 'red';

  /* 方法 */

  /**
   * 获取小程序配置信息
   * @return null
   */
  public onGetAppConfig(): void {
    const queryParams = {
      sgId: Number.parseInt(this.$route.params.id),
    };
    IPSService.getBasicConfigInfo({ queryParams }).then((res: ItemObject) => {
      this.appConfig = res;
      this.themeType = res.themeCode || 'red'; // 模板主题
      if (res.configList) {
        res.configList.forEach((item, index) => {
          if (item.isDefault === 1) { this.isDefaultIndex = index; }
        });
      }
    });
  }

  /**
   * 当前选择的模块
   * @param value
   */
  public onChangeSelect(value): void {
    this.selectedDeploy = value;
  }

  /**
   * 选择编辑的模块
   * @param index
   */
  public onEditModular(index): void {
    this.selectModularIndex = index;
    this.isShowEdit = true;
    this.selectModular = this.appConfig.configList[index];
    this.chooseIcon.icon_code = this.selectModular.classId;
    this.chooseIcon.choose_icon_code = this.selectModular.chooseClassId;
  }

  /**
   * 选择使用的模块
   * @param checked
   * @param item
   */
  public onChangeBox(checked: boolean, item) {
    item.isOpen = checked ? 1 : 0;
    if (item.configType == 'SITE' && !checked) {
      this.appConfig.isProductDetail = 0;
    } else if (item.configType == 'SITE' && checked) {
      this.appConfig.isProductDetail = 1;
    }
  }

  /**
   * 取消模块编辑
   * @return null
   */
  public onClearIconInfo(): void {
    this.isShowEdit = false;
    this.chooseIcon = {};
  }

  /**
   * 编辑模块完成
   */
  public onConfirmIcon(): void {
    if (this.selectModular.className !== '') {
      this.selectModular.classId = this.chooseIcon.icon_code;
      this.selectModular.chooseClassId = this.chooseIcon.choose_icon_code;
      this.appConfig.configList[this.selectModularIndex] = this.selectModular;
      this.isShowEdit = false;
      this.$message.success('编辑成功');
    }
  }

  /**
   * 当前选择的图标
   * @param icon
   */
  public onCheckIcon(icon): void {
    this.chooseIcon = icon;
  }

  /**
   * 提交基础配置表单
   * @return null
   */
  public onSubmitConfigData(): void {
    if (!this.appConfig.appName) { delete this.appConfig.appName; }
    if (!this.appConfig.wxAppId) { delete this.appConfig.wxAppId; }
    this.appConfig.sgId = Number.parseInt(this.$route.params.id);
    this.appConfig['themeCode'] = this.themeType; // 模板主题
    const postParams = this.appConfig;
    IPSService.updateBasicConfig({ postParams }).then((res) => {
      if (res) {
        this.$message.success('保存成功');
      } else {
        this.$message.error('保存失败');
      }
    });
  }

  /**
   * 设为首页默认
   * @param {number} index
   * @return null
   */
  public onSetDefault(index: number): void {
    this.appConfig.configList.forEach((item) => {
      item.isDefault = 0;
    });
    this.appConfig.configList[index].isDefault = 1;
    this.isDefaultIndex = index;
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.onGetAppConfig(); // 获取小程序配置信息
    this.iconList = JSON.parse(JSON.stringify(require('../../../services/json/ICONS.json')));
  }
}
